import * as S from './DownloadProgress.styled';
import { Palette } from 'config';
import PropTypes from 'prop-types';

export const DownloadProgress = ({ percentage, width, height, style }) => {
  const gradient = `conic-gradient(${Palette.Primary._500} ${percentage}%, ${
    Palette.PrimaryGray._100
  } 0 ${100 - percentage}%)`;

  return (
    <S.Container style={style}>
      <S.Border>
        <S.ProgressBar
          style={{ background: gradient }}
          width={width}
          height={height}
        ></S.ProgressBar>
      </S.Border>
      <S.Text>Uploading ...</S.Text>
    </S.Container>
  );
};

DownloadProgress.propTypes = {
  percentage: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};
